
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphNodeDialog extends Serenity.EntityDialog<GraphNodeRow, any> {
        protected getFormKey() { return GraphNodeForm.formKey; }
        protected getIdProperty() { return GraphNodeRow.idProperty; }
        protected getLocalTextPrefix() { return GraphNodeRow.localTextPrefix; }
        protected getNameProperty() { return GraphNodeRow.nameProperty; }
        protected getService() { return GraphNodeService.baseUrl; }

        protected form = new GraphNodeForm(this.idPrefix);

    }
}